import styled from "styled-components";

const ListEntryAction = styled.div<{spacing?: number}>`
    flex: 0 0 auto;
    padding: ${props => props.theme.spacing(0, props.spacing || 1)};
    justify-content: center;
    display: flex;
    align-items: center;
`;

export default ListEntryAction;
export { ListEntryAction };
